import OperatorProviderList from "./providerList/providerList";

export default OperatorProviderList;
